import { Role, SimulateDto } from '../api/api';
import WorkClient from '../api/workClient';
import { getUserEmail, getUserName } from '../utils/authProvider/authProvider';
import NotificationService from './NotificationService';
import { log } from '../utils/logging/log';

export const allowedTestingEnviroments =
  window._env_.ENVIRONMENT === 'Local' || window._env_.ENVIRONMENT === 'Dev' || window._env_.ENVIRONMENT === 'Test';

function createSimulateDto(): SimulateDto {
  return {
    assignedToEmail: getUserEmail(),
    assignedToName: getUserName(),
    plannedArrival: new Date().toISOString(),
    plannedDuration: 4,
    isFixed: true,
    numberOfDays: 1
  };
}

// Should ONLY be called in dev and test
const simulatePlanning = (workTaskId: number) => {
  if (!allowedTestingEnviroments) return;
  
  const body = createSimulateDto();
  return WorkClient.simulatePlanning(workTaskId, body)
    .then(() => {
      NotificationService.success(`Opgave: ${workTaskId} er blevet planlagt på dig selv`);
    })
    .catch((err) => {
      log(err);
      NotificationService.error(`Opgave: ${workTaskId} er ikke blevet planlagt. Fejlkode: ${err}`);
    });
};

// Should ONLY be called in dev and test
const simulateBooking = (workTaskId: number) => {
  if (!allowedTestingEnviroments) return;

  const body = createSimulateDto();
  return WorkClient.simulateBooking(workTaskId, body)
      .then(() => {
        NotificationService.success(`Opgave: ${workTaskId} er booket på dig selv`);
      })
      .catch((err) => {
        log(err);
        NotificationService.error(`Opgave: ${workTaskId} er ikke booket. Fejlkode: ${err}`);
      });
};

// Should ONLY be called in dev and test
const changeRole = (role: Role) => {
  return WorkClient.changeRole(role);
};

const TestingService = {
  simulatePlanning,
  simulateBooking,
  changeRole
};

export default TestingService;
